export const IMPORT_STATUSES = {
  ACCEPTED: "Accepted",
  PENDING: "Pending",
};
